import { Module } from 'vuex'
import actions from './actions'
import ProductState from '@vue-storefront/core/modules/catalog/types/ProductState'

export const productModule: Module<ProductState, any> = {
  actions
}
